import { useLocation, Link } from 'react-router-dom';
import { LayoutDashboard, CalendarDays, FileText, ClipboardList, Users, CheckSquare, DollarSign } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const roleName = (role: unknown) => {
    if (typeof role === 'string') return role;
    if (role && typeof role === 'object' && 'name' in role) return String((role as any).name);
    return '';
};

const hasAnyRole = (role: string, allowed: string[]) => {
    const normalized = role.toUpperCase();
    return allowed.some(item => normalized === item.toUpperCase() || normalized.includes(item.toUpperCase()));
};

const selfServiceItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Home' },
    { path: '/timesheets/schedule', icon: CalendarDays, label: 'Schedule' },
    { path: '/my-roster', icon: ClipboardList, label: 'Mine' },
    { path: '/team-roster', icon: Users, label: 'Team' },
    { path: '/timesheets/my', icon: FileText, label: 'Hours' },
];

const adminItems = [
    { path: '/admin/dashboard', icon: LayoutDashboard, label: 'Home' },
    { path: '/admin/users', icon: Users, label: 'Users' },
    { path: '/admin/roster', icon: ClipboardList, label: 'Roster' },
    { path: '/payroll', icon: DollarSign, label: 'Payroll' },
    { path: '/timesheets/approvals', icon: CheckSquare, label: 'Approvals' },
];

const BottomNav = () => {
    const location = useLocation();
    const { user } = useAuth();
    const currentRole = roleName(user?.role);
    const isAdmin = hasAnyRole(currentRole, ['Super Admin', 'ADMIN', 'Administrator', 'Station Manager']);
    const navItems = isAdmin ? adminItems : selfServiceItems;

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 lg:hidden pb-[env(safe-area-inset-bottom)]">
            <div className="flex justify-around items-center h-16 px-2">
                {navItems.map(({ path, icon: Icon, label }) => {
                    const isActive = location.pathname.startsWith(path);
                    return (
                        <Link key={path} to={path}
                            className={`flex flex-col items-center gap-0.5 px-2 py-1 rounded-lg transition-colors min-w-[58px] ${isActive ? 'text-blue-600' : 'text-slate-400 hover:text-slate-600'}`}
                        >
                            <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} />
                            <span className="text-[10px] font-medium">{label}</span>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
};

export default BottomNav;
